<template>

	<div>
		<ul v-if="convs">
			<li v-for="c in convs">
				<router-link class="waves-effect" :to="{ name: 'conversation', params: {id: c.tid} }" active-class="active"  exact>
					<div class="user-avatar-w">
						<ProfilePic :w="40" :h="40" :c="'#00000'" v-if="c.username"/>
					</div>
					<div class="message-content" :class="(c.unread > 0) ? 'isbold' : ''">


						<div class="message-from" v-if="c.userFullName.length > 1">
							{{ getParticipants(c.participant) }}
						</div>
						<div class="message-from" v-else-if="c.username">
							{{ c.username }}
						</div>
						<div class="message-d">

							{{ c.subject }}
							<div class="unread-count float-right" v-if="c.unread > 0">
								{{  c.unread | tnPlus }}
							</div>

							<div class="user-date" v-if="c.lastMessageDate">
								{{  c.lastMessageDate | timeAgo(session.timezone) }}
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</ul>

		<ul v-else class="text-center">
			<li class="not_found">
				<i class="ti-close"></i>
				<small class="capitalize message-from">{{ t.conversation.not_found }}</small>
			</li>
		</ul>
	</div>

</template>

<script>
    import ProfilePic from '@/components/user/ProfilePic'

    export default {
        name: 'messagesWidget',
        components: { ProfilePic },
        data () {
            return {
                convs: false,
                session: window.session,
                t: this.$root.t,
            }
        },
        mounted () {
            setTimeout(this.fetchConversations(), 1000);
        },
        methods: {
            fetchConversations (cid = 0) {
                this.convsLoader = (cid) ? false : true;
                this.$http.get(api+'api/v1/message/conversation',
                    {params: {cid:  cid}}
                ).then(response => {
                    if(cid > 0) {
                        this.convs[cid] = response.body.result.conversations[cid];
                        this.convsLoader = false;
                    }else {
                        // get body data
                        this.convs = response.body.result.conversations;

                        this.$emit('conversations', response.body.result.conversations);
                        this.convsLoader = false;
                    }
                }, response => {
                    // error callback
                    switch(response.status) {
                        case 404:
                            this.convs = 404;
                            break;
                    }
                })
            },
            getParticipants (Participants) {
                var pname = new Array;

                Participants.forEach(function(p) {
                    if(p.id != session.uid) {
                        pname.push(p.userFullName);
                    }

                });

                return pname.join(',');
            }
        }
    }
</script>

<style scoped>
	.message-d {
		color: rgba(0, 0, 0, 0.7);
		margin-top: 5px;
		margin-bottom: 0px;
		font-weight: 500;
	}
	.message-from {
		color: #75508e !important
	}

	.user-date {
		float: right;
		padding: 2px 7px;
		margin-left: 5px;
		background-color: #fff;
		border-radius: 12px;
		font-size: 0.72rem;
		color: rgba(0, 0, 0, 0.3);
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
	.not_found {
		padding: 30px 30px
	}
</style>



// WEBPACK FOOTER //
// src/components/message/widget/messages.vue